import { grey, pink } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    plain: true;
    default: true;
  }
}

declare module '@mui/material/styles' {
  interface Palette {
    plain: Palette['primary'];
    default: Palette['primary'];
  }

  interface PaletteOptions {
    plain?: PaletteOptions['primary'];
    default?: PaletteOptions['primary'];
  }
}

const theme = createTheme({
  palette: {
    background: {
      default: "#fafafa",
    },
    plain: {
      main: grey[300],
      dark: grey[400],
    },
    default: {
      main: grey[700],
    },
    secondary: {
      main: "#00B4C8",
      contrastText: "#fff",
    },
  },
  components: {
    MuiTextField: {
      variants: [
        {
          props: { variant: "outlined", size: "small" },
          style: {
            "& label.Mui-focused": {
              color: pink[500],
            },
            "& .MuiOutlinedInput-root": {
              "&.Mui-focused fieldset": {
                borderColor: pink[500],
              },
            },
          },
        },
      ],
    },
    MuiMenu: {
      variants: [
        {
          props: {
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
          },
          style: {},
        },
      ],
    },
    MuiButton: {
      variants: [
        {
          props: { variant: "contained" },
          style: {},
        },
      ],
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          "&.Mui-checked": {
            color: pink[500],
          },
          "&.MuiCheckbox-indeterminate": {
            color: pink[500],
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: pink[500],
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            color: grey[700],
          },
        },
      },
    },
  },
});

export default theme;